module.exports = __webpack_public_path__ + "img/1w.44786d15.svg";